<template>
  <div id="photo-model-dialog-info" class="font-body x-center">
    <div style="overflow-y: auto;">
      <el-image
        class="info-image"
        style="width:80vw"
        :src="photos[0]"
        fit="contain"
      ></el-image>
      <ul class="list">
        <li
          class="list-item"
          v-for="(item, index) in infoList"
          :key="index"
          v-show="item.value"
        >
          <span>{{ item.label }}</span
          ><span>{{ item.value }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
function transformArea(data) {
  const area = data ? data + '平方米' : data;
  return area;
}
export default {
  props: {
    relicInfo: {
      type: Object,
      default: () => ({})
    },
    photos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      infoList: [
        {
          icon: 'iconfont icon icon-shequ',
          label: '历史建筑编号：',
          value: this.relicInfo.number
        },
        {
          icon: 'iconfont icon icon-shequ',
          label: '建筑名称：',
          value: this.relicInfo.name
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '保护类别：',
          value: this.relicInfo.protect
        },
        {
          icon: 'iconfont icon icon-shequ',
          label: '所在社区：',
          value: this.relicInfo.community
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '建筑面积：',
          value: transformArea(this.relicInfo.coveredArea)
        },
        {
          icon: 'iconfont icon icon-jianzhucengshu',
          label: '建筑层数：',
          value: this.relicInfo.height
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '现状功能：',
          value: this.relicInfo.used
        },
        {
          icon: 'iconfont icon-xianzhuangchanquan',
          label: '现状产权：',
          value: this.relicInfo.equity
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '地址：',
          value: this.relicInfo.address
        },
        {
          icon: 'iconfont icon icon-zhandimianji',
          label: '占地面积：',
          value: transformArea(this.relicInfo.floorSpace)
        },
        {
          icon: 'iconfont icon icon-jianzhujiegou',
          label: '建筑结构：',
          value: this.relicInfo.structure
        },
        {
          label: '简介：',
          value: this.relicInfo.value
        }
      ]
    };
  }
};
</script>

<style lang="scss">
#photo-model-dialog-info {
  padding-top: 5px;
  width: 100vw;
  display: flex;
  justify-content: center;
  .info-image {
    border-radius: 3px;
  }
  .list {
    margin-top: 20px;
    width: 80vw;
    &-item {
      padding: 5px 0px;
      line-height: 1.5em;
    }
  }
}
</style>
